import type { SVGProps } from 'react';

/** Figma `metric-pitch.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MetricPitchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M10.0003 17.272C14.0169 17.272 17.273 14.0159 17.273 9.99929C17.273 5.98267 14.0169 2.72656 10.0003 2.72656C5.98365 2.72656 2.72754 5.98267 2.72754 9.99929C2.72754 14.0159 5.98365 17.272 10.0003 17.272Z"
        stroke="#E58C1A"
        strokeWidth="1.4"
      />
      <path
        id="Vector_2"
        d="M10.0003 12.272C11.2555 12.272 12.273 11.2545 12.273 9.99929C12.273 8.7441 11.2555 7.72656 10.0003 7.72656C8.74507 7.72656 7.72754 8.7441 7.72754 9.99929C7.72754 11.2545 8.74507 12.272 10.0003 12.272Z"
        fill="#E58C1A"
      />
    </g>
  </svg>
);
